import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

interface ListParams {
  page?: number;
  pageSize?: number;
  status?: string;
  offerId?: string;
  affiliateId?: string;
}

export function useOfferApplications(params: ListParams = {}) {
  const { page = 1, pageSize = 50, status, offerId, affiliateId } = params;

  return useQuery({
    queryKey: ["offer-applications", { page, pageSize, status, offerId, affiliateId }],
    queryFn: async () => {
      const qp: Record<string, string> = { page: String(page), pageSize: String(pageSize) };
      if (status) qp.status = status;
      if (offerId) qp.offer_id = offerId;
      if (affiliateId) qp.affiliate_id = affiliateId;
      const res = await api.get("/v1/offer-applications", qp);
      if (!res.ok) throw new Error("Failed to fetch applications");
      return res.json();
    },
  });
}

export function useReviewApplication() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, status }: { id: number; status: "approved" | "rejected" }) => {
      const res = await api.patch(`/v1/offer-applications/${id}`, { status });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.error || "Failed to review application");
      }
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["offer-applications"] });
      queryClient.invalidateQueries({ queryKey: ["offers"] });
    },
  });
}
